import Modal from 'react-modal'

export { Modal }
